import styled from "styled-components";

export const BoxBtn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 40px;
`;
